
import ProductCarouselSwiper from '../ui/landing-page/ProductCarouselSwiper.vue'

export default {
  components: { ProductCarouselSwiper },
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      products: [],
      leadingSubtitle: null,
      title: null,
      subtitle: null,
      clickable: true,
      hideAuctionCountDown: false
    }
  },
  async fetch () {
    const activeProducts = await this.getProducts(
      this.section.config
    )

    this.hideAuctionCountDown = this.section.hideAuctionCountDown ? this.section.hideAuctionCountDown : false
    if (activeProducts.length > 1) {
      this.products = activeProducts
      this.title = this.section.config.title
      this.leadingSubtitle = this.section.config.leadingSubtitle
      this.subtitle = this.section.config.subtitle
      return
    }

    this.products = await this.getProducts(this.section.alternative)
    this.title = this.section.alternative.title
    this.leadingSubtitle = this.section.alternative.leadingSubtitle
    this.subtitle = this.section.alternative.subtitle
  },
  computed: {
    textCentered () {
      return this.section.centered ? ' text-center ' : ''
    }
  },
  methods: {
    async getProducts ({ auctionStatus, limit, orderBy, orderDesc, productType, country }) {
      const response = await this.$axios.get('/public/catalog/products', {
        params: { auctionStatus, limit, orderBy, orderDesc, productType, country }
      })
      const { products } = response.data

      return products.map((product) => {
        const titleMaxLength = 28
        const title =
          product.title.length > titleMaxLength
            ? `${product.title.slice(0, titleMaxLength)}...`
            : product.title

        return {
          product,
          slug: product.slug,
          path: product.image,
          title,
          entityId: product.entityId
        }
      })
    }
  }
}
